import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../siteadmin/school-type-setup/shared/StringRequest";
import { DataService_TimeScanTypeSetup } from "../shared/data.service";
import { TimeScanTypeInsertRequest } from "../shared/TimeScanTypeInsertRequest";

@Component({
	selector: "app-admin-setup-add-time-scan-type",
	templateUrl: "./admin-setup-add-time-scan-type.component.html",
	styleUrls: ["./admin-setup-add-time-scan-type.component.css"],
})
export class AdminSetupAddTimeScanTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: DataService_TimeScanTypeSetup
	) {}

	ngOnInit(): void {
		//Load data from parent
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	//Data from parent
	user: any;
	SchoolID: any;

	//Form
	Code: any;
	Desc: any;
	AllSchools: boolean = false;

	errorMessage: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onAdd() {
		this.CheckCode();
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.adminSetupService.TimeScanTypeCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Time Scan Type Code already in use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Desc,
		};

		var result = this.adminSetupService.TimeScanTypeDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Time Scan Type Description already in use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		var DefinedBy: any = this.user.UserLevelID == 1 ? 4 : 3;

		let parms: TimeScanTypeInsertRequest = {
			Code: this.Code,
			Desc: this.Desc,
			DefinedByID: DefinedBy,
			SchoolID: this.AllSchools == true ? -1 : this.SchoolID,
		};

		var result = this.adminSetupService.TimeScanTypeInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Time Scan Type was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Time Scan Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
